import React from 'react'
import { Divider, Col, Row } from 'antd'
import { EmployeeListItem } from '../../../services/api/employees'
import { Search } from './components/Search'
import { EmployeesTable } from './components/EmployeesTable'
import CompanySelect from './components/CompanySelect'

type Props = {
  isLoading: boolean
  data?: EmployeeListItem[]
  meta?: {
    page: number | null
    perPage: number | null
    totalCount?: number
  }
  companyId?: string
  search?: string
  handleSearch: (value?: string) => void
  onSearchChange: (value?: string) => void
  onCompanyChange: (companyId?: string) => void
  onPaginationChange: (page: number, perPage?: number) => void
}

export const View: React.FunctionComponent<Props> = ({
  isLoading,
  data,
  onPaginationChange,
  handleSearch,
  onSearchChange,
  search,
  companyId,
  meta,
  onCompanyChange,
}) => {
  return (
    <>
      <h2>Сотрудники</h2>
      <Row gutter={[32, 0]}>
        <Col span={8}>
          <Search
            value={search}
            onSearchChange={onSearchChange}
            handleSearch={handleSearch}
          />
        </Col>
        <Col span={16}>
          <CompanySelect
            companyId={companyId}
            onCompanyChange={onCompanyChange}
          />
        </Col>
      </Row>

      <Divider />

      <EmployeesTable
        data={data}
        meta={meta}
        isLoading={isLoading}
        onPaginationChange={onPaginationChange}
      />
    </>
  )
}
